<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="editAccess()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ userName }}</span>
      <h2>{{ 'PROFILE_POPUP_ADD_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <h3>{{ 'PROFILE_POPUP_REVIEW_ACCESS' | translate }}</h3>
  <p *ngIf="reviewMode === 'locks'" class="subtitle">
    {{ 'PROFILE_POPUP_REVIEW_ASSIGNED_ACCESS' | translate: { name: userName } }}
  </p>

  <div class="review-list">
    <div class="building-card">
      <button
        type="button"
        class="building-header"
        (click)="toggleExpanded()"
        [attr.aria-expanded]="expanded"
        aria-controls="review-access-units"
      >
        <span class="building-icon" aria-hidden="true">
          <img [src]="reviewMode === 'locks' ? 'assets/svg/ico-default-home.svg' : 'assets/svg/ico-building-gray.svg'" alt="" />
        </span>
        <span class="building-name" [title]="reviewMode === 'locks' ? selectedUnit?.label : building?.buildingName">
          {{ reviewMode === 'locks' ? selectedUnit?.label : building?.buildingName }}
        </span>
        <span class="count">{{ reviewMode === 'locks' ? selectedLocks.length : reviewUnits.length }}</span>
        <mat-icon aria-hidden="true">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <ul *ngIf="expanded" id="review-access-units" class="units">
        <ng-container *ngIf="reviewMode === 'units'; else lockRows">
          <li *ngFor="let unit of reviewUnits" class="unit">
            <img src="assets/svg/ico-default-home.svg" alt="" aria-hidden="true" />
            <span class="unit-text">
              <span class="unit-name" [title]="unit.label">{{ unit.label }}</span>
              <span class="unit-location">
                {{ unit.floorName }}<ng-container *ngIf="unit.wingName">, {{ unit.wingName }} {{ 'WING' | translate }}</ng-container>
              </span>
            </span>
          </li>
        </ng-container>
        <ng-template #lockRows>
          <li *ngFor="let lock of selectedLocks" class="unit">
            <img src="assets/svg/ico-lock-user-access.svg" alt="" aria-hidden="true" />
            <span class="unit-text">
              <span class="unit-name" [title]="lock.deviceName || ''">{{ lock.deviceName }}</span>
              <span class="unit-location" [title]="lockLocation">{{ lockLocation }}</span>
            </span>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>

  <div class="actions">
    <button type="button" class="primary-button" [disabled]="reviewMode === 'locks' && !selectedLocks.length" (click)="continue()">{{ 'CONTINUE' | translate }}</button>
    <button type="button" class="secondary-button" (click)="editAccess()">{{ 'PROFILE_POPUP_EDIT_ACCESS' | translate }}</button>
  </div>
</section>
